import { useStore } from "@/stores/RootStoreContext"

import { MenuAdmin } from "@/components/admin/MenuAdmin"
import { MenuClient } from "@/components/client/MenuClient"
import { MenuManager } from "@/components/manager/MenuManager"

import { Header } from "../../header/Header"
import { IMG } from "../../CONST"

import { type FC } from "react"

import style from "./style.module.scss"
import { useCurrencyStore } from "@/stores/currencyStore"
import clsx from "clsx"
import Skeleton from "@/ui/components/Skeleton"

const currenciesArray = [
  "USD",
  "EUR",
  "CNY",
  "GBP",
  "USD/EUR",
  "USD/CNY",
  "USD/GBP",
  "EUR/USD",
  "CNY/USD",
  "GBP/USD",
  "CHF",
  "QAR",
  "KZT",
  "ZAR",
  "INR",
  "VND",
  "THB",
  "UZS",
  "AUD",
  "KRW",
  "JPY",
  "PLN",
  "MDL",
  "BYN",
  "IDR",
  "AMD",
  "HUF",
  "TRY",
  "TJS",
  "HKD",
  "AED",
  "RSD",
  "DKK",
  "CAD",
  "XDR",
  "BGN",
  "NOK",
  "GEL",
  "EGP",
  "RON",
  "SGD",
  "AZN",
  "CZK",
  "KGS",
  "SEK",
  "NZD",
  "TMT",
  "BRL",
  "UAH"
]

const ExchangeRates: FC = () => {
  const { userStore } = useStore()

  const currencyDate = useCurrencyStore(state => state.date)
  const currencies = useCurrencyStore(state => state.currencies)
  const bcaCurrencies = useCurrencyStore(state => state.bca)
  const isLoading = useCurrencyStore(state => state.isLoading)

  return (
    <>
      {userStore.isClient ? (
        <MenuClient active={"rates"} />
      ) : userStore.isManager ? (
        <MenuManager active={"rates"} />
      ) : (
        <MenuAdmin active={"rates"} />
      )}

      <main className="main-container" id="scrollable">
        <Header />

        <div className="container">
          <div className={style.ratesChapter}>
            <div className={style.ratesDate}>
              {currencyDate
                ? new Date(currencyDate).toLocaleDateString("ru", {
                    year: "numeric",
                    month: "long",
                    day: "numeric"
                  })
                : "-"}
            </div>

            <section className="header-chapter">
              <div className="headr-chapter-name">
                <div className="header-chapter-icon">
                  <img src={IMG.exchange} alt="" className="header-chapter-img" />
                </div>
                <h2 className="heading-chapter">Курсы валют</h2>
              </div>

              <div className={style.currentBlock}>
                <span>Валюта</span>
                <div>RUR</div>
              </div>
            </section>
          </div>

          <div className={style.explainText}>
            <p>В данном разделе представлены курсы валют ЦБ РФ и FX зарубежных банков</p>
          </div>

          <div className="main-content--wrapper">
            <section className="main-content">
              <div className={style.table}>
                <div className={clsx(style.row, style.headerRow)}>
                  <div>Валюта</div>
                  <div>ЦБ РФ</div>
                  <div>FX Индонезия</div>
                </div>
                <div className={clsx(style.row, style.subheaderRow)}>
                  <div></div>
                  <div>Установленный</div>
                  <div className={clsx(style.rowBcaItem, style.rowBcaSubheaderItem)}>
                    <span>Покупка</span>
                    <span>/</span>
                    <span>Продажа</span>
                  </div>
                </div>
                {isLoading && (
                  <div className="skeleton-wrapper">
                    <Skeleton rows={4} gutterTop />
                  </div>
                )}
                {!isLoading &&
                  currencies &&
                  currenciesArray.map(key => {
                    if (!currencies.hasOwnProperty(key)) {
                      return null
                    }

                    const isBcaXrates = bcaCurrencies.xRates?.hasOwnProperty(key)

                    return (
                      <div className={style.row} key={key}>
                        <div className={style.currencyValue}>{key}</div>
                        <div>{Number(currencies[key]).toFixed(4)}</div>
                        <div className={style.rowBcaItem}>
                          {isBcaXrates ? (
                            <span>{bcaCurrencies.xRates ? bcaCurrencies.xRates[key] || "-" : "-"}</span>
                          ) : (
                            <span>{bcaCurrencies.buy ? bcaCurrencies.buy[key] || "-" : "-"}</span>
                          )}
                          <span>/</span>
                          <span>{bcaCurrencies.sell ? bcaCurrencies.sell[key] || "-" : "-"}</span>
                        </div>
                      </div>
                    )
                  })}
              </div>
            </section>
          </div>
        </div>
      </main>
    </>
  )
}

export default ExchangeRates
